import pluralize from 'pluralize'
import React, { useState } from 'react'

import { normalize, stringifyDate, usePet } from '../../modules'

import Modal from "../reusable/modal"
import Receive from '../reusable/receive'

const ByStaff = ({ toggle, visible, ranges, onOK }) => {
    const [persons, setPersons] = useState([])

    const [{ loading, error }, byStaff] = usePet('salesByStaff',
        ranges ? 
            { 
                from: ranges[0]?._d ?? null, 
                to: ranges[1]?._d ?? null 
            }
        : {}
    , { notify: true, callback: ({ data }) => setPersons(data) })
    
    return (
        <Modal
            w={ 800 }
            centered={ false }
            title="Sales By Staff"
            toggle={toggle}
            visible={visible}>
            <Receive
                error={error}
                loading={loading}
                progress>
                <>
                    <p className="text-lg font-bold">Sales { String(ranges[0]) === String(ranges[1]) ? `For ${stringifyDate(ranges[0]?._d, true)}` : `From ${stringifyDate(ranges[0]?._d, true)} To ${stringifyDate(ranges[1]?._d, true)}` }</p>
                    <div className="grid grid-cols-12 gap-6 mb-5">
                        {
                            persons.map(person =>
                                <div className="flex flex-col p-4 col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-gray-200">
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-800 mb-2">{ person.name }</h2>
                                        <div className="text-xs font-semibold text-gray-400 uppercase mb-1">{ person.total } { pluralize('Bills', person.total) } Handled</div>
                                        <div className="text-xs font-semibold text-green-400 uppercase mb-1">{ person.closed } { pluralize('Bills', person.closed) } Closed</div>
                                        <div className="text-xs font-semibold text-yellow-400 uppercase mb-1">{ person.open } { pluralize('Bills', person.open) } Open</div>
                                        <div className="flex items-start">
                                            <div className="text-2xl font-bold text-gray-800 mr-2">Ksh. { normalize(person.sales - person.discount) }</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </>
            </Receive>
            <div className="flex justify-end">
                <button type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Print</button>
            </div>
        </Modal>
    )
}

export default ByStaff